import { z } from 'zod';

export const TRIP_ACCESSORIAL_DECISIONS = ['confirmed', 'adjusted', 'dropped'] as const;
export type TripAccessorialDecision = (typeof TRIP_ACCESSORIAL_DECISIONS)[number];

export const MAX_ACCESSORIAL_QUANTITY = 1000;
export const MAX_ACCESSORIAL_REASON_LENGTH = 500;

const reason = z.string().trim().min(1, 'Give a reason').max(MAX_ACCESSORIAL_REASON_LENGTH);

/**
 * The closer's answer on one proposed accessorial (gitaumoses4/chukua#120). The unit price is never in the body: an adjustment changes the quantity
 * and the amount follows from the job's priced terms. `basisHash` says which version of the proposal was on screen, and `expectedDecisionId` which
 * decision it replaces (null for the first), so a stale screen or a second screen is refused rather than double-counted.
 */
export const tripAccessorialDecisionSchema = z.discriminatedUnion('decision', [
  z.object({
    decision: z.literal('confirmed'),
    proposalKey: z.string().min(1).max(100),
    basisHash: z.string().min(1).max(64),
    expectedDecisionId: z.uuid().nullable(),
    reason: reason.optional(),
  }),
  z.object({
    decision: z.literal('adjusted'),
    proposalKey: z.string().min(1).max(100),
    basisHash: z.string().min(1).max(64),
    expectedDecisionId: z.uuid().nullable(),
    quantity: z.number().int().min(1).max(MAX_ACCESSORIAL_QUANTITY),
    reason,
  }),
  z.object({
    decision: z.literal('dropped'),
    proposalKey: z.string().min(1).max(100),
    basisHash: z.string().min(1).max(64),
    expectedDecisionId: z.uuid().nullable(),
    reason,
  }),
]);
export type TripAccessorialDecisionInput = z.infer<typeof tripAccessorialDecisionSchema>;
